import withWidgetData from './withWidgetData';
export default withWidgetData;



// WEBPACK FOOTER //
// ./src/components/withWidgetData/index.js